import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

/**
 * Mobile-only floating primary CTA pill. Appears after the hero.
 * Positioned bottom-left so it never collides with the Kostaja badge
 * (which shifts up on mobile once this bar is visible — see KostajaBadge).
 * The visibility state is exposed via a body data-attribute so the
 * Kostaja badge can react to it.
 */
export default function MobileStickyCTA() {
  const { pathname } = useLocation();
  const [visible, setVisible] = React.useState(false);

  React.useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 520);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  React.useEffect(() => {
    if (typeof document !== "undefined") {
      document.body.dataset.stickyCta = visible ? "on" : "off";
    }
    return () => {
      if (typeof document !== "undefined") delete document.body.dataset.stickyCta;
    };
  }, [visible]);

  // Hide on the Contact page itself
  if (pathname === "/contact") return null;

  return (
    <div
      className={`lg:hidden fixed bottom-3 left-3 z-[60] transition-all duration-300 ease-out ${
        visible ? "opacity-100 translate-y-0 pointer-events-auto" : "opacity-0 translate-y-3 pointer-events-none"
      }`}
      data-testid="mobile-sticky-cta"
      aria-hidden={!visible}
    >
      <Link
        to="/contact"
        className="group inline-flex items-center gap-2 bg-brand-black text-white rounded-full px-4 py-2.5 text-[13px] font-bold tracking-tight shadow-[0_10px_30px_-10px_rgba(0,0,0,0.7)] active:scale-[0.98] transition-transform"
      >
        Get My Property Market-Ready
        <ArrowUpRight className="h-4 w-4" />
      </Link>
    </div>
  );
}
